import React, { createContext, useState, useContext } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState([]);

    const addToCart = (product) => {
        // Check if the same product with the same purchase option already exists in the cart
        const existingItem = cart.find((item) => 
            item._id === product._id && 
            item.selectedOption === product.selectedOption
        );

        if (existingItem) {
            // If item with same option already exists, prevent adding another quantity
            alert('This item with the selected option is already in your cart.');
            return;
        }

        // Add item with a quantity of 1 and ensure it has productId for coupon validation
        const cartItem = {
            ...product, 
            productId: product._id, 
            quantity: 1,
            // Create a unique cart ID that includes the purchase option
            cartItemId: `${product._id}_${product.selectedOption || 'default'}`
        };
        
        setCart([...cart, cartItem]);
    };

    const removeFromCart = (cartItemId) => {
        setCart((prevCart) => prevCart.filter((item) => {
            // Support both old format (productId) and new format (cartItemId)
            return item.cartItemId ? item.cartItemId !== cartItemId : item._id !== cartItemId;
        }));
    };

    const clearCart = () => {
        setCart([]);
    };

    return <CartContext.Provider value={{ cart, addToCart, removeFromCart, clearCart }}>{children}</CartContext.Provider>;
};
